import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'stop-page-header',
  imports: [RouterLink],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent {
  readonly username = input.required<string>();
  readonly initials = input.required<string>();
  readonly userMenuOpen = input.required<boolean>();
  readonly userMenuAriaLabel = input.required<string>();
  readonly logoutLabel = input.required<string>();
  readonly closeMenuAriaLabel = input.required<string>();

  readonly toggleMenu = output<void>();
  readonly closeMenu = output<void>();
}
